export default __webpack_public_path__ + "static/media/newv.b5f80e53.webm";